const SummaryEntry = ({ value }) => {
  return (
    <div style={{ fontSize: "1.8em", color: "rgb(96, 78, 151)" }}>{value}</div>
  );
};

export default SummaryEntry;
